import { Card, Stack } from '@chakra-ui/react';
import type { ComponentProps, FC } from 'react';
import ReactMarkdown from 'react-markdown';

import { ContentWrapper } from '../../../../shared/ui/content-wrapper/content-wrapper';
import { ContactSalesButton } from '../../../trialUser/ContactSalesButton';
import contactUsContent from '../markdown/contact-us-content.md';
import { CentrializedLayout } from './centralized-layout';

interface TrialPageContentProps {
  children?: React.ReactNode;
}

const SimpleCard: FC<ComponentProps<typeof Card>> = (props) => {
  return (
    <Card
      p={6}
      borderRadius="xl"
      backgroundColor="white"
      shadow="none"
      {...props}
    />
  );
};

export const TrailPageConent: FC<TrialPageContentProps> = ({ children }) => {
  return (
    <CentrializedLayout>
      <Stack spacing={6} mb={8}>
        <SimpleCard p={10}>{children}</SimpleCard>
        <SimpleCard px={10} pt={10} pb={7}>
          <Stack spacing={4}>
            <ContentWrapper>
              <ReactMarkdown>{contactUsContent}</ReactMarkdown>
            </ContentWrapper>
            <ContactSalesButton />
          </Stack>
        </SimpleCard>
      </Stack>
    </CentrializedLayout>
  );
};
